export const CLEANS_TIMELINE_PREV_DAYS = 365
export const CLEANS_TIMELINE_DATE_RANGE = 365
export const FETCH_CLEANS_RESERVATIONS_MAX_SIZE = 175
export const FETCH_UNITS_MAX_SIZE = 60
export const IMPERSONATION_IDP_SCOPE = 'fieldops-admin-guestworks:impersonate'
